module.exports = require('./helpers/bundle-url').getBundleURL('01RMl') + "GDG.0afa3c63.png";